// extracted by mini-css-extract-plugin
export default {"count":"qOlx4O","button":"uBCCgI"};